module.exports = __webpack_public_path__ + "res/13-img_game_bg_l.19cc347b1968f43f23f4767c1436ea93.webp";